import { useCallback, useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { toast } from "react-toastify"

import Layout from "../../layouts/layout"
import MainPageLayout from "../../components/main-page-layout/mainPageLayout"
import { useDropzone } from "react-dropzone"
import { DateTimePicker } from "react-advance-jalaali-datepicker"
import { useRequestProcessor } from "../../api/requestProcessor"
import { uploadImage, uploadVideo } from "../../api/upload-files"
import { storeSingleWorkshops } from "../../api/workshops"
import { getAllProvinces, getProvinceCities } from "../../api/city-province"
import { domainName } from "../../constants/site"


import { CKEditor } from "@ckeditor/ckeditor5-react"
import ClassicEditor from "@ckeditor/ckeditor5-build-classic"


import Select from "react-select"
import makeAnimated from 'react-select/animated';
import { getAllCategoriesWithType } from "../../api/categories"
import { getWebisteData, updateWebsiteInfo } from "../../api/website"

const Require = () => {
    return <span className="text-red-500">*</span>
}

const EditWebsite = () => {

    const [name, setName] = useState("")

    const [isVideo, setIsVideo] = useState(true)

    const [videoData, setVideoData] = useState({
        url: "",
        extenstion: ""
    })
    const [aparatUrl, setAparatUrl] = useState("")  

    const [convertedContent, setConvertedContent] = useState(null);

    const navigate = useNavigate()

    const { Query, Mutate } = useRequestProcessor()


    const { data: fetchedData, isLoading, isError } = Query(
        ['getWebsiteInfo'],
        () => getWebisteData()
    );

    const { mutate: mutateWebsite } = Mutate(
        "updateWebsite",
        updateWebsiteInfo,
        {
            onSuccess: (data) => {
                toast.success(data.message + " تا چند ثانیه دیگر به صفحه اصلی منتقل خواهید شد.", {
                    autoClose: 2500,
                    progress: false,
                })
                setTimeout(() => { navigate("/admin/dashboard") }, 3000)
                //This is the response you get back
            }
            ,
            onError: (data) => {
                toast.error(data.response.data.message)
            }
        }
    );

    useEffect(()=>{
        setName(fetchedData?.data?.title_home)
        setConvertedContent(fetchedData?.data?.body_home)
        if(fetchedData?.data?.files?.type === "aparat"){
            setAparatUrl(fetchedData?.data?.files?.file?.htmlCode)
        }
        else if(fetchedData?.data?.files?.type === "video"){
            setVideoData({url:fetchedData?.data?.files?.file?.path})
        }

    },[fetchedData])


    const { mutate: mutateVideo } = Mutate(
        "uploadVideo",
        uploadVideo,
        {
            onSuccess: (data) => {
                toast.success("ویدیو با موفقیت آپلود شد", {
                    autoClose: 2500,
                    progress: false,
                })
                setVideoData({ url: data.data.filePath, extenstion: data.data.fileExtension })
                //This is the response you get back
            }
            ,
            onError: (data) => {
                toast.error(data.response.data.message)
            }
            
        }
    );


    const onDropVideo = useCallback(acceptedFiles => {
        let formData = new FormData();
        formData.append("video", acceptedFiles[0])
        mutateVideo(formData)
    }, [])



    const { getRootProps: getVideoRootprops, getInputProps: getVideoInputProps, isDragActive: isVideoDragActive } = useDropzone({
        onDrop: onDropVideo, maxFiles: 1, multiple: false, accept: {
            'video/*': [],
        }
    });


    async function onSubmitHandler(e) {
        e.preventDefault();
        let data = {
            title_home: name,
            body_home: convertedContent,
            video_type: isVideo ? "video" : "aparat",
            video: isVideo ?
                {
                    filePath: videoData.url ? { path: videoData.url } : null,
                    fileExtension: videoData.extenstion ?? null
                } :
                {
                    htmlCode: aparatUrl ?? null
                }
            ,
        }
        mutateWebsite(data)
    }



    return (
        <Layout >
            <MainPageLayout backButton sectionTitle={"مشخصات وبسایت :"} >
                <form onSubmit={onSubmitHandler}>
                    <div className="flex wsm:flex-col">
                        <div className='flex flex-col my-4 w-full'>
                            <div className='flex flex-col my-3'>
                                <p className='pr-3 pb-1'>عنوان وبسایت :<Require /></p>
                                <input type="text" value={name} onChange={(e) => setName(e.target.value)} className=' form-input !w-3/4' placeholder='نام وبسایت' />
                            </div>
                            
                        </div>
                        <div className="w-full flex flex-col">
                            <div className="flex flex-col mb-4">
                                <div className="flex justify-between text-center items-center">
                                    <p className='pr-3 pb-1'>انتخاب ویدیو وبسایت :<Require /></p>
                                    <div className="mx-10 items-center flex wsm:!mx-0 m-2">
                                        <p>آپارات</p>
                                        <label class="relative inline-flex  cursor-pointer mx-2">
                                            <input type="checkbox" value={isVideo} onChange={(e) => setIsVideo(prev => !prev)} class="sr-only peer" />
                                            <div class={`w-11 h-6  rounded-full peer bg-sky-300  peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all `}></div>
                                        </label>
                                        <p>فایل ویدیو</p>
                                    </div>
                                </div>
                                {
                                    isVideo ?
                                        <form className="flex justify-center h-full items-center border border-dashed py-5 bg-gray-100 cursor-pointer rounded-2xl hover:border-sky-600" {...getVideoRootprops()}>
                                            <input
                                                {...getVideoInputProps()} />
                                            {
                                                <p> فایل را انتخاب یا به اینجا بکشید</p>
                                            }
                                        </form>
                                        :
                                        <div className='flex flex-col my-3'>
                                            <p className='pr-3 pb-1'>لینک کد آپارات :</p>
                                            <input type="text" value={aparatUrl} onChange={(e) => setAparatUrl(e.target.value)} className=' form-input !w-full' placeholder='لینک را جایگذاری کنید' />
                                        </div>
                                }
                                <div className="flex justify-center my-4">
                                    <video src={videoData.url && domainName + videoData.url} className="w-[150px]" alt="" />
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className="flex flex-col my-3">
                        <p className='pr-3 pb-1'>متن وبسایت :</p>
                        <CKEditor
                            editor={ClassicEditor}
                            data={convertedContent ?? ""}
                            config={{
                                language: {
                                    ui: "en",
                                    content: "ar"
                                }
                            }}

                            onChange={(event, editor) => {
                                const data = editor.getData();
                                setConvertedContent(data);
                            }}

                        />
                    </div>
                    <p className='pr-3 text-sm'>متاتگ های وبسایت بر اساس کلمات نوشته شما ساخته میشود</p>

                    <div id='form-add-button--container'>
                        <button type="submit" id='form-add-button'>ثبت</button>
                    </div>
                </form>
            </MainPageLayout>
        </Layout>
    )
}

export default EditWebsite